import _ from "lodash";
import {
  Component,
} from "react";
import {
  Button,
} from "react-bootstrap";
import {
  Awesome,
  Checkbox,
} from "CommonComponents/bricks";
import FloatingPopup from "CommonComponents/floating-popup";
import {
  injectFunction,
} from "CommonCore/schema-util";

import store from "CommonState/store";

const DEFAULT_MAX_FIXED_COLUMNS = 4;
const ACTIONS_FIXED_FIELD = "__actions__";

@store
export default class FixedColumnSelector extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const {
      schema,
      fixedColumnConfig = {},
      injects,
      hasActions,
      maxFixedColumns,
    } = this.props;
    const {
      open,
    } = this.state;

    const columns = schema.table.filter(c => !_.isObject(c.hideFromList)
      ? !c.hideFromList
      : !injectFunction(c.hideFromList, injects)());
    const selectableColumns = hasActions
      ? [...columns, { field: ACTIONS_FIXED_FIELD, display: "Aktionen" }]
      : columns;
    const effectiveMaxFixedColumns = _.isFinite(maxFixedColumns)
      ? Math.max(0, maxFixedColumns)
      : Math.min(DEFAULT_MAX_FIXED_COLUMNS, selectableColumns.length);
    const selectedFixedCount = selectableColumns.filter(c => !!fixedColumnConfig[c.field]).length;
    const canSelectMore = selectedFixedCount < effectiveMaxFixedColumns;

    return <FloatingPopup
      open={open}
      onClose={this.closeMenu}
      placement='bottom-end'
      resizeToFit
      renderTarget={ref => (
        <Button
          ref={ref}
          variant='outline-primary'
          onClick={this.toggleMenu}>
          <Awesome name='thumbtack' alt='Spalten fixieren' />
          &#x200b;
        </Button>
      )}
      renderPopup={(ref, style) => (
        <div ref={ref} style={{ ...style, zIndex: 1090 /* Damit Select-Box über dem Tabellen Fuß und dem horizontalen Scrollbalken liegt. */ }}>
          <div className='column-selector-popup'>
            <div className='column-selector-heading'>Spalten fixieren</div>
            {selectableColumns.map(c => {
              const checked = !!fixedColumnConfig[c.field];
              return <Checkbox
                vertical
                key={c.field}
                label={c.display}
                checked={checked}
                disabled={!checked && !canSelectMore}
                onChange={evt => this.toggleColumn(c, evt.target.checked)}
              />;
            })}
            <div className='column-selector-footer'>
              <div className='column-selector-note'>
                Maximal {effectiveMaxFixedColumns} fixierte Spalten.
              </div>
              <Button variant='outline-primary' onClick={this.reset}>
                <Awesome name='undo' />&nbsp;Auf Standard zurücksetzen
              </Button>
            </div>
          </div>
        </div>
      )}
    />;
  }

  toggleMenu = () => {
    this.setState({ open: !this.state.open });
  };

  closeMenu = () => {
    this.setState({ open: false });
  };

  toggleColumn = ({ field }, fixed) => {
    const { schema, list, setUiListColumnFixed } = this.props;
    setUiListColumnFixed(schema.syncSettingsWith || list, field, fixed);
  };

  reset = () => {
    const { schema, list, setUiListColumnFixedDefault } = this.props;
    setUiListColumnFixedDefault(schema.syncSettingsWith || list);
  };
}
